// 地図マーカー（ピン）の SVG 生成
// 通常: 白丸 + 青枠 + 青ピンアイコン / 選択中: 青塗り + 白ピンアイコン

// ピンアイコン（Figma: map_dummy 内 Vector）
const GLYPH_PATH =
    "M6 11C7.32608 11 8.59785 10.4732 9.53553 9.53553C10.4732 8.59785 11 7.32608 11 6C11 4.67392 10.4732 3.40215 9.53553 2.46447C8.59785 1.52678 7.32608 1 6 1C4.67392 1 3.40215 1.52678 2.46447 2.46447C1.52678 3.40215 1 4.67392 1 6C1 7.32608 1.52678 8.59785 2.46447 9.53553C3.40215 10.4732 4.67392 11 6 11ZM6 11V16M3.91667 6C3.91667 5.44747 4.13616 4.91756 4.52686 4.52686C4.91756 4.13616 5.44747 3.91667 6 3.91667";

/**
 * SVG 文字列から SVGElement を生成する
 * @param {string} svgString - SVG のマークアップ文字列
 * @returns {SVGSVGElement}
 */
const createSvgElement = (svgString) => {
    const parser = new DOMParser();
    const document = parser.parseFromString(svgString, "image/svg+xml");
    return document.documentElement;
};

/**
 * 通常ピンを生成する
 * @param {string} type - 物件種別（data-type 属性に付与される）
 * @returns {SVGSVGElement}
 */
const renderDefaultPin = (type) =>
    createSvgElement(`
      <svg data-type="${type}" width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg" style="filter: drop-shadow(0 4px 4px rgba(0, 0, 0, 0.25));">
        <circle class="background" cx="19" cy="15" r="14" fill="#fff" stroke="#156082" stroke-width="2"/>
        <svg x="14" y="7.5" width="10" height="15" viewBox="0 0 12 17" preserveAspectRatio="none">
          <path d="${GLYPH_PATH}" stroke="#156082" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </svg>
    `);

/**
 * 選択中ピンを生成する
 * @param {string} type - 物件種別（data-type 属性に付与される）
 * @returns {SVGSVGElement}
 */
const renderSelectedPin = (type) =>
    createSvgElement(`
      <svg data-type="${type}" width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg" style="filter: drop-shadow(0 4px 4px rgba(0, 0, 0, 0.25));">
        <circle class="background" cx="19" cy="15" r="15" fill="#156082"/>
        <circle cx="19" cy="15" r="14" stroke="#fff" stroke-width="2"/>
        <svg x="14" y="7.5" width="10" height="15" viewBox="0 0 12 17" preserveAspectRatio="none">
          <path d="${GLYPH_PATH}" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </svg>
    `);

/**
 * ピン SVG を生成する
 * @param {string} type - 物件種別（data-type 属性に付与される）
 * @param {boolean} [isSelected=false] - 選択中スタイルにするか
 * @returns {SVGSVGElement} マーカーの content に渡す SVG 要素
 */
export const createPin = (type, isSelected = false) =>
    isSelected ? renderSelectedPin(type) : renderDefaultPin(type);
